const config = {
  method: "GET",
  headers: { accept: "application/json" }
};

const request = async (url) => {
  try {
    const response = await fetch(url, config);
    return await response.json();
  } catch (error) {
    throw Error(`API CALL FAILED: ${error}`);
  }
};

export default request;
